<div class="plan-container">
  <div class="plan current-basic">
    <div class="plan-top">
      <div class="plan-title">Basic
        <div class="current-basic-badge">Current</div>
      </div>
      <div class="plan-price" *ngIf="isHasStandardPlanFee()">
        <div *ngIf="isHasViewPricePermission" style="margin-bottom: 8px; display: flex; align-items: flex-end;">
          <div class="price">{{me()?.currency_symbol}}{{dealerPlanService.mainDealerPlanPriceStandard}}</div>
          <div style="display: flex; flex-direction: column; align-items: flex-end; margin-left: 8px;">
            <div>/month per Dealer Account</div>
          </div>
        </div>
      </div>
      <div class="plan-price" *ngIf="!isHasStandardPlanFee()"><i class="material-icons" style="color: #8792A2; font-size: 60px">forum</i>
        <div class="plan-description">No monthly dealer fee.</div>
      </div>
    </div>
    <div class="plan-contents">
      <div class="plan-content-description"><i class="material-icons plan-icon text-primary">check</i>
        <div>Maintain Current Features</div>
      </div>
      <div class="plan-content-description"><i class="material-icons plan-icon text-primary">check</i>
        <div>30 Days Cloud Video Storage</div>
      </div>
      <div class="plan-content-description"><i class="material-icons plan-icon text-blue-gray-high">close</i>
        <div>Cloud-Based AI Filtering</div>
      </div>
      <div class="plan-content-description"><i class="material-icons plan-icon text-blue-gray-high">close</i>
        <div>API Access</div>
      </div>
      <div class="plan-content-description"><i class="material-icons plan-icon text-blue-gray-high">close</i>
        <div>Enhanced Features</div>
      </div>
    </div>
  </div>
  <div class="plan-wide">
    <div class="plan-top">
      <div class="plan-title">Reseller Plan</div>
      <div class="plan-price">
        <div *ngIf="isHasViewPricePermission" style="margin-bottom: 8px; display: flex; align-items: flex-end;">
          <div class="price">{{me()?.currency_symbol}}{{dealerPlanService.mainDealerPlanPriceReseller}}</div>
          <div style="display: flex; flex-direction: column; align-items: flex-end; margin-left: 8px;">
            <div>/month per Dealer Account</div>
          </div>
        </div>
        <div class="plan-description">CHeKT Monitoring Center Reseller plan providing wholesale rates for CHeKT services and monitored accounts.</div>
      </div>
    </div>
    <div class="plan-contents">
      <div style="margin-bottom: 24px;">All Basic Features +</div>
      <div style="display: flex; flex-wrap: wrap; justify-content: space-between;">
        <div class="plan-content-description"><i class="material-icons plan-icon text-primary">check</i>
          <div>CHeKT Reseller Services</div>
        </div>
        <div class="plan-content-description"><i class="material-icons plan-icon text-primary">check</i>
          <div>Cloud-Based AI Filtering</div>
        </div>
        <div class="plan-content-description"><i class="material-icons plan-icon text-primary">check</i>
          <div>Local Bridge API</div>
        </div>
        <div class="plan-content-description"><i class="material-icons plan-icon text-primary">check</i>
          <div>Low Cost Remote Access</div>
        </div>
        <div class="plan-content-description"><i class="material-icons plan-icon text-primary">check</i>
          <div>Automation Rules</div>
        </div>
        <div class="plan-content-description"><i class="material-icons plan-icon text-primary">check</i>
          <div>Custom AI Capabilities</div>
        </div>
        <div class="plan-content-description"><i class="material-icons plan-icon text-primary">check</i>
          <div>Alarm Incident Report</div>
        </div>
        <div class="plan-content-description"><i class="material-icons plan-icon text-primary">check</i>
          <div>Lower Video Event Costs</div>
        </div>
        <div class="plan-content-description"><i class="material-icons plan-icon text-primary">check</i>
          <div>Cloud API Access</div>
        </div>
        <div class="plan-content-description"><i class="material-icons plan-icon text-primary">check</i>
          <div>VMS Video Vault</div>
        </div>
      </div>
      <div class="plan-action">
        <div class="redirect" (click)="goToPricingPlanDescription()">Go to Detail →</div>
        <button class="secondary-button" style="width: 230px; padding: 10px 25px" (click)="onClickShowChangingPlanModal(4)">Upgrade your account</button>
      </div>
    </div>
  </div>
</div>